module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body--wrapper",
    attrs: {
      "id": "IndexAbouts"
    }
  }, [_c('section', {
    staticClass: "sub--header diagonal-shadow mg-bottom-diagonal"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "box-desc"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tAbout us\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit. Eligendi distinctio iusto sunt ducimus eos nesciunt impedit ex ipsam. Ratione necessitatibus, beatae nesciunt, excepturi error exercitationem. Maxime voluptatem, fugit laboriosam assumenda?\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-lg btn-warning",
    attrs: {
      "to": 'apply-project'
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t  Konsultasikan pada kami\n\t\t\t\t\t\t\t")])], 1)])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section--wrapper bg-white"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box-information"
  }, [_c('div', {
    staticClass: "title--top"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tabout us\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit. Nemo dolore ipsum, autem ipsa est doloribus iure necessitatibus impedit explicabo optio nihil assumenda velit dignissimos vel, sapiente aperiam voluptatibus accusantium eius.\n\t\t\t\t\t\t\t\t")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "btn btn-lg btn-danger",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tCOMPANY PROFILE DOWNLOAD\n\t\t\t\t\t\t\t")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section--wrapper about-us"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "title--top"
  }, [_c('div', {
    staticClass: "title txt-white"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tPerkenalkan Team Kami\n\t\t\t\t\t\t\t")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box-list-team"
  }, [_c('div', {
    staticClass: "box-list-team__image"
  }, [_c('img', {
    attrs: {
      "src": "static/images/team/lutfi.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team__name"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tLutfi Satria Ramdhani\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team__position"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tSistem Analis\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team"
  }, [_c('div', {
    staticClass: "box-list-team__image"
  }, [_c('img', {
    attrs: {
      "src": "static/images/team/febry.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team__name"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tFebryan Setiawan\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team__position"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tSr.Backend Developer\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team"
  }, [_c('div', {
    staticClass: "box-list-team__image"
  }, [_c('img', {
    attrs: {
      "src": "static/images/team/fathan.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team__name"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tFathan Rohman\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team__position"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tSr.Frontend Developer - UI/UX Designer\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team"
  }, [_c('div', {
    staticClass: "box-list-team__image"
  }, [_c('img', {
    attrs: {
      "src": "static/images/team/chris.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team__name"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tChristian Tobing\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team__position"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tBussines Development\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team"
  }, [_c('div', {
    staticClass: "box-list-team__image"
  }, [_c('img', {
    attrs: {
      "src": "static/images/team/farry.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team__name"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tFarry Abimael Argobie\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team__position"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tSr.Fullstack Developer\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team"
  }, [_c('div', {
    staticClass: "box-list-team__image"
  }, [_c('img', {
    attrs: {
      "src": "static/images/team/jos.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team__name"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tRamdhani Haris\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team__position"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tFrontend Developer\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team"
  }, [_c('div', {
    staticClass: "box-list-team__image"
  }, [_c('img', {
    attrs: {
      "src": "static/images/team/audi.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team__name"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tAudi Irawan\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team__position"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tMobile Developer\n\t\t\t\t\t\t\t")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a82b91ee","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/aboutus/IndexAboutus.vue
// module id = 74
// module chunks = 0